import Vue from "vue";
import "@/assets/css/reset.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import base from "@/utils/common.js";
import vant from "@/utils/vant-ui";
import "@/apis/index";
import sensors from "@/utils/sensors.js";
import jsBridge from "@51job/jbs-jsbridge";
import "@/components/components.js";
import JbsApplyJob from "@51job/jbs-h5-component/lib/JbsApplyJob";
import VConsole from "vconsole";
import fastClick from 'fastclick'
import jsBridgeNext from "@51job/jbs-jsbridge";
process.env.NODE_ENV !== "production" ? new VConsole() : "";

Vue.component("JbsApplyJob", JbsApplyJob); //h5 职位卡片直投

Vue.config.productionTip = false;
Vue.prototype.$jsBridgeNext = jsBridgeNext;
Vue.prototype.$sensors = sensors.sensors;
Vue.prototype.$exposure = sensors;
Vue.prototype.$jsBridge = jsBridge;
Vue.prototype.$axiosInstances = {
  cupid: "",
};
import wx from "weixin-js-sdk";
Vue.prototype.$wx = wx;
Vue.use(vant);
Vue.prototype.$base = base;
Vue.prototype.$EventBus = new Vue();
// 完整加载
import VueLuckyCanvas from "@lucky-canvas/vue";
fastClick.attach(document.body)
Vue.use(VueLuckyCanvas);
export default new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
